import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import VCalendar from 'v-calendar';
import i18n from './i18n';
import { createPinia } from 'pinia';
import Toaster from '@meforma/vue-toaster';
import VueGoogleMaps from '@fawmi/vue-google-maps';
import MyGocuButton from './components/common/buttons/MyGocuButton.vue';
import { sanitizeHtml } from './directives/sanitizeHtml';
import { translateForced } from './directives/translateForced';
import { VueWhatsAppWidget } from '@greenborn/vue3-whatsapp-widget';
import HomeApiService from '@/services/api/HomeApiService';
import { agenciaStoreModule } from '@/store_pinia/agencia';
import { useFontStore } from '@/store_pinia/fontStore';
import { appGlobalStore } from '@/store_pinia/app';
import axios from 'axios';
import { addMetaPixel } from '@/services/utils/metaPixelUtils';
import { addGtagPixel } from '@/services/utils/gtagPixelUtils';
import { registerAppVisit } from '@/helpers/numVisitasUtils';

async function loadAgenciaConfig() {
  const agenciaStore = agenciaStoreModule();
  const storeGlobal = appGlobalStore();
  const res = await HomeApiService.getAgencia();
  agenciaStore.setData(res);
  storeGlobal.setValoresResources(res.recursos);
  const permisos = await axios.get(agenciaStore.getPermisos);
  storeGlobal.setPermisos(permisos.data);
  selectorIdiomas(res.recursos);
}

async function loadAgencyFonts() {
  await useFontStore().loadAgencyFonts();
}

async function initHtml() {
  const agenciaStore = agenciaStoreModule();

  let file = document.createElement('link');
  let headTitle = document.querySelector('head');
  let setFavicon = document.createElement('link');

  document.title = agenciaStore.getMetaTitulo;
  document.documentElement.setAttribute('lang', agenciaStore.locale || 'es');

  let descMeta = document.querySelector('meta[name="description"]');
  if (!descMeta) {
    descMeta = document.createElement('meta');
    descMeta.name = 'description';
    descMeta.content = agenciaStore.getMetaDescripcion;
    document.head.appendChild(descMeta);
  }

  file.rel = 'stylesheet';
  file.href = agenciaStore.getCss;
  document.head.appendChild(file);

  setFavicon.setAttribute('rel', 'shortcut icon');
  setFavicon.setAttribute('href', agenciaStore.getFavicon);
  headTitle.appendChild(setFavicon);

  if (agenciaStore.getMeta) {
    addMetaPixel(agenciaStore.getMeta);
  }
  if (agenciaStore.getGoogleAnalitycs) {
    addGtagPixel(agenciaStore.getGoogleAnalitycs);
  }
}

function selectorIdiomas(response) {
  const storeGlobal = appGlobalStore();
  axios.get(response.translations_en).then(res => {
    storeGlobal.setTranslations(res.data, 'en');
  });
  axios.get(response.translations_es).then(res => {
    storeGlobal.setTranslations(res.data, 'es');
  });
  axios.get(response.translations_fr).then(res => {
    storeGlobal.setTranslations(res.data, 'fr');
  });
  axios.get(response.translations_it).then(res => {
    storeGlobal.setTranslations(res.data, 'it');
  });
  if (response.translations_de) {
    axios.get(response.translations_de).then(res => {
      storeGlobal.setTranslations(res.data, 'de');
    });
  }
  if (response.translations_tr) {
    axios.get(response.translations_tr).then(res => {
      storeGlobal.setTranslations(res.data, 'tr');
    });
  }
}

async function initApp() {
  const app = createApp(App)
    .use(i18n)
    .use(createPinia())
    .use(router)
    .use(VCalendar, {})
    .use(Toaster)
    .use(VueWhatsAppWidget)
    .component('mg-btn', MyGocuButton)
    .use(VueGoogleMaps, {
      load: {
        key: process.env.VUE_APP_GOOGLE_MAPS_API_KEY,
        language: 'es',
      },
    })
    .directive('sanitize-html', sanitizeHtml)
    .directive('translate-forced', translateForced);

  await Promise.all([loadAgenciaConfig(), loadAgencyFonts()]);
  await initHtml();
	registerAppVisit();

  // Place here any plugin that needs back information from the back-end

  app.mount('#app');
}

initApp();
